// ACTIONS
export const FETCH = 'offerzen/company/FETCH'
export const FETCH_LOADING = 'offerzen/company/FETCH_LOADING'
export const FETCH_SUCCESS = 'offerzen/company/FETCH_SUCCESS'
export const RESET_COMPANY = 'offerzen/company/RESET_COMPANY'

// ACTION CREATORS
export const fetch = id => ({
  type: FETCH,
  payload: id,
})

export const fetchLoading = value => ({
  type: FETCH_LOADING,
  payload: value,
})

export const fetchSuccess = data => ({
  type: FETCH_SUCCESS,
  payload: {
    loading: false,
    company: data.result,
  },
})

export const resetCompany = () => ({
  type: RESET_COMPANY,
  payload: {
    loading: true,
    company: {},
  },
})

// REDUCERS
const initialState = {
  loading: true,
}

const companyReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LOADING:
      return {
        ...state,
        loading: action.payload,
      }

    case FETCH_SUCCESS:
      return {
        ...state,
        loading: action.payload.loading,
        company: action.payload.company,
      }

    case RESET_COMPANY:
      return {
        ...state,
        ...action.payload,
      }

    default:
      return state
  }
}

export default companyReducer
